import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterUser_template} from "./filterUser_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {filterArticle_template} from "./filterArticle_template";

declare var ko: any;

export class article10DayPerformance_template extends vnTemplate {

    protected viewMode: filterDropdown_template;
    protected filter: filterSimple_template;
    protected filterUser: filterUser_template;
    protected filterContentType: multipleSelector_template;
    protected filterNetworkCategory: multipleSelector_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected filterPreset: filterPreset_template;

    protected getTemplateHtml(): string {

        return `
            <div class="sub-header filter-preset w-justify ">

                    ` + this.filterPreset.getHtmlBuild() + `
            </div>
            
            <div class="sub-header">

                
                <div class="w-justify">
                    <div class="w-left">
                        <div>
                            <label class="form-label form-label-box">Google Traffic Source</label>
                            ${ this.viewMode.getHtmlBuild() }
                        </div>
                        ` + this.filterContentType.getHtmlBuild() + `
                        ` + this.filterNetworkCategory.getHtmlBuild() + `
                         <!-- ko if: $data.isUserFilterEnable() -->
                         ` + this.filterUser.getHtmlBuild() + `
                        <!-- /ko -->                   
                    </div>
                </div>
            </div>
     
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-users"></div>
                    <div id="selected-contentType"></div>
                    <div id="selected-networkCategory"></div>
                </div>
            </div>

           
            <div class="list-header">
                <div class="w-justify">
                    <div class="w-left">
                        <!-- ko if: isRecentArticleStatsActive() == '1' -->
                        
                            <!-- ko if: $data.selectedUserName() -->
                               <!--  <strong class="section-title">  Articles Published By <br><span data-bind="text: selectedUserName"></span><br> In The Last Month </strong> -->
                            <!-- /ko -->
                            
                            <!-- ko ifnot: $data.selectedUserName() -->
                                <!-- <strong class="section-title">  Articles Published In The Last Month </strong> -->
                            <!-- /ko -->
                       
                        <!-- /ko -->
                        
                        
                        <!-- ko if: isRecentArticleStatsActive() == '0'-->
                        
                            <!-- ko if: $data.selectedUserName() -->
                                <!-- <strong class="section-title"> Articles Published By <br><span data-bind="text: selectedUserName"></span><br> Over A Month Ago</strong> -->
                            <!-- /ko -->
                            
                            <!-- ko ifnot: $data.selectedUserName() -->
                               <!--  <strong class="section-title">  Articles Published Over A Month Ago </strong> -->
                            <!-- /ko -->
                       
                        <!-- /ko -->
                        
                        
                        <!-- ko if: $data.isOwnArticleFilterEnable() -->
                        <div class="form-check-inline">                  
                            <input type="checkbox" data-bind="checked: isOwnArticleStatsActive, click: showOwnArticleStats" id="ownArticleStats">
                            <label for="ownArticleStats" class="form-label icon i-check">Only Show My Articles</label>   
                        </div>
                        <!-- /ko -->
                    </div>
                </div>
                
                <div class="w-justify">  
                    <div class="w-left" >
                        <div class="form-group row article-leaderboard-filter">
                             <legend class="form-legend">Show articles published</legend>
                             <div class="form-check-inline width-auto">
                                <input type="radio" name="articleStats" id="active_yes" value="1" data-bind="checked: isRecentArticleStatsActive, event: {change : showArticleStats}"/>
                                <label class="form-label" for="active_yes">In The Last Month</label>
                             </div>   
                             <div class="form-check-inline width-auto">
                                 <input type="radio" name="articleStats" id="active_no" value="0" data-bind="checked: isRecentArticleStatsActive, event: {change : showArticleStats}"/>
                                 <label  class="form-label" for="active_no">Over A Month Ago</label>   
                             </div>
                        </div>
                    </div>
    
                    <div class="w-center">
                        ` + this.filter.getHtmlBuild() + `
                    </div>
                
                    <div class="w-right">
                        ` + this.pagination.getHtmlBuild() + `
                    </div>
                

                </div>
               
            </div>
            
            <div class="w-list-results article-leaderboard" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'clicks') }, css: { 'list-sort-desc': orderByAndDirection()=='clicks_DESC', 'list-sort-asc': orderByAndDirection()=='clicks_ASC' }">TIERS</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='idArticle_DESC', 'list-sort-asc': orderByAndDirection()=='idArticle_ASC' }">Article ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idPS') }, css: { 'list-sort-desc': orderByAndDirection()=='idPS_DESC', 'list-sort-asc': orderByAndDirection()=='idPS_ASC' }">Publish Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'date') }, css: { 'list-sort-desc': orderByAndDirection()=='date_DESC', 'list-sort-asc': orderByAndDirection()=='date_ASC' }">Date Published</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Author Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentType') }, css: { 'list-sort-desc': orderByAndDirection()=='contentType_DESC', 'list-sort-asc': orderByAndDirection()=='contentType_ASC'}">Content type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'networkCategory') }, css: { 'list-sort-desc': orderByAndDirection()=='networkCategory_DESC', 'list-sort-asc': orderByAndDirection()=='networkCategory_ASC'} "> Network Category</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: articles">                        
                        <tr  class="cursor">
                            <td class="tier">
                                <span data-bind=" attr: { 'class' : 'tier-' + global_tier }"><span data-bind="text: global_tier ? 'Tier Across Brand: ' + global_tier : '' "></span></span>
                                <span data-bind=" attr: { 'class' : 'tier-' + secondary_tier }"><span data-bind="text: secondary_tier ? 'Tier Across Selected Filters: ' + secondary_tier : '' "></span></span>
                            </td>
                            <td><span data-bind="text: id"></span></td>
                            <td><span data-bind="text: title"></span></td> 
                            <td><span data-bind="text: idPS == 3 ? 'Published' : 'Republished' "></span></td>
                            <td><span data-bind="text: date"></span></td>
                            <td><span data-bind="text: name"></span></td>
                            <td><span data-bind="text: contentType"></span></td>
                            <td><span data-bind="text: networkCategory"></span></td>                         
                        </tr>
                    </tbody>
                </table>
            </div>   
            `;
    }

    protected initPartial(): void {

        this.viewMode = new filterDropdown_template('viewMode', this.getTemplateViewModel(), this.caller);
        this.viewMode.setLabel("view mode");
        this.viewMode.setOptions( [
            {id: 'search', name: 'Search'},
            {id: 'discover', name: 'Discover/Google News'}
        ]);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 100;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.filterUser = new filterUser_template("filterUser", this.getTemplateViewModel(), this.caller);
        this.filterUser.asMultipleSelectionMode();
        this.filterUser.setTagContainerId('selected-users');
        this.filterUser.setTagContainerCaption('Selected user:');
        this.filterUser.setPlaceholderText("User");

        this.filterContentType = new multipleSelector_template("filterContentType", this.getTemplateViewModel(), this.caller);
        this.filterContentType.setLabel("Content Type");
        //this.filterContentType.setFilterContainerClass('margin-neg');
        this.filterContentType.setTagContainerId('selected-contentType');
        this.filterContentType.setTagContainerCaption('Selected content type:');

        this.filterNetworkCategory = new multipleSelector_template("filterNetworkCategory", this.getTemplateViewModel(), this.caller);
        this.filterNetworkCategory.setLabel("Network Category");
        //this.filterNetworkCategory.setFilterContainerClass('margin-neg');
        this.filterNetworkCategory.setTagContainerId('selected-networkCategory');
        this.filterNetworkCategory.setTagContainerCaption('Selected network category:');

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('10DayPerformance');
    }


    protected getTemplateName(): string {
        return "articlePerformance-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            articles: ko.observableArray([])
            , user: ko.observable(null)
            , selectedUserName: ko.observable(null)
            , brand: ko.observable(null)
            , disableActive: ko.observable(true)
            , articleStats: ko.observable("")
            , isRecentArticleStatsActive: ko.observable("1")
            , isOwnArticleStatsActive:ko.observable(false)
            , isUserFilterEnable: ko.observable(false)
            , isOwnArticleFilterEnable: ko.observable(false)

            ,showArticleStats: function (data) {
                huit_neuf_this.showArticleStats();
                return true;
            }
            ,showOwnArticleStats: function (data) {
                huit_neuf_this.showOwnArticleStats();
                return true;
            }

            ,orderBy: ko.observable("clicks")
            , orderByDirection: ko.observable("DESC")
            , orderByAndDirection: ko.observable("clicks_DESC")
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
        };
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.articlesListReorder();
    }
    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy : this.viewModel.list.orderBy,
            orderByDirection : this.viewModel.list.orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: '10DayPerformance',
            filters      : {
                viewMode: this.getTemplateViewModel().viewMode.selectedOption,
                isRecentArticleStatsActive: this.getTemplateViewModel().isRecentArticleStatsActive,
                isOwnArticleStatsActive: this.getTemplateViewModel().isOwnArticleStatsActive,
                users: this.filterUser.getUsersForRequest(),
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                contentTypeIds: this.getTemplateViewModel().filterContentType.selectedItems,
                networkCategoryIds: this.getTemplateViewModel().filterNetworkCategory.selectedItems,
            },
        }
    }

    public setStats(articles) {

        this.getTemplateViewModel().articles(articles);
    }

    public setUser(user) {

        this.getTemplateViewModel().user(user);
    }

    public setSelectedUserName(name) {

        this.getTemplateViewModel().selectedUserName(name);
    }

    public showArticleStats() {

        this.caller.onClickShowRecentArticleStats();
        return true;
    }


    public setGroupContentTypeFilterItems(groupContentTypes){
        let groups = [];
        for ( let groupContentType of groupContentTypes){
            let group = {"name" : groupContentType.name, "items" : groupContentType.contentTypes};
            groups.push(group);
        }

        this.filterContentType.setMultiSectionItems(groups);
        this.filterContentType.setLabel('Content Type');
    }
    public setGroupCategoryFilterItems(groupCategories){
        let groups = [];
        for ( let groupCategory of groupCategories){
            let group = {"name" : groupCategory.name, "items" :groupCategory.networkCategories};
            groups.push(group);
        }

        this.filterNetworkCategory.setMultiSectionItems(groups);
        this.filterNetworkCategory.setLabel('Network Category');
    }

    public showOwnArticleStats() {

        let user = this.getTemplateViewModel().user();
        let fullName = '';

        if(this.getTemplateViewModel().isOwnArticleStatsActive()){
            fullName = user.valnet_user.fullName
        }

        this.setSelectedUserName(fullName);
        this.caller.onClickShowOwnArticleStats();
        return true;
    }

    public setUserFilterEnable(value){

        this.getTemplateViewModel().isUserFilterEnable(value);
        this.getTemplateViewModel().isOwnArticleFilterEnable(!value);
    }

    public setContentType(filterList: Array<{ id: number, name: string }>): void {

        this.filterContentType.setItems(filterList);
    }
    public setNetworkCategory(filterList: Array<{ id: number, name: string }>): void {

        this.filterNetworkCategory.setItems(filterList);
    }
    public setResultInfo(nbResults, nbPages, execTime ){

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            //isRecentArticleStatsActive

            this.getTemplateViewModel().viewMode.selectedOption(urlParams.viewMode);

            this.setFilterSelectedItems(this.filterContentType, urlParams.contentTypeIds);
            this.setFilterSelectedItems(this.filterNetworkCategory, urlParams.networkCategoryIds);

            // keyword filter.
            let keywordString = urlParams.keywords
            if(urlParams.keywords){
                keywordString = urlParams.keywords.replaceAll("+", " ");
            }
            this.filter.getTemplateViewModel().filterKeyword(keywordString);

            if(urlParams.users) {
                this.filterUser.setSelectedUsersFromRequestParams(urlParams.users);
            } else {
                this.filterUser.resetTagContainer();
            }
        }
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    private setUserPresetFilter(userFilter: filterUser_template, idUser?: number, name?: string): void {

        userFilter.getTemplateViewModel().idUser(idUser);
        userFilter.getTemplateViewModel().user(name);
        userFilter.toggleCloseButton();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/article10DayPerformance_template.ts